import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { User } from 'src/models/user';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.scss']
})
export class SiteLayoutComponent {

  @ViewChild('searchtypedropdown') navDropdown: ElementRef;

  public scrollControlDisabled = true;

  public searchFormGroup: FormGroup;
  public searchType = 'radio';
  public searchText = '';

  public user: User;

  constructor(private router: Router, private accountService: AccountService) {
    this.searchFormGroup = new FormGroup({
      search: new FormControl()
    });

    this.searchFormGroup.get('search').valueChanges.pipe(debounceTime(500)).subscribe((value: string) => {
      this.searchText = value;
      
      this.onSearchSubmit();
    });

    this.accountService.loggedInUser.subscribe((user: User) => {
      this.user = user;
    })
  }

  public setSearchType(type: string) {
    const currentSearchType = this.searchType;

    this.searchType = type;

    if (currentSearchType !== type && this.searchText.length > 0) {
        this.onSearchSubmit();
    }

    this.navDropdown.nativeElement.classList.remove('open');
  }

  public onSearchSubmit() {
    if (this.searchText.length > 0) {
      this.router.navigate(['/suche/' + this.searchType, this.searchText]);
    } else {
      //this.location.back();
    }
  }

  public logout() {
    this.accountService.logout().subscribe((loggedOut: boolean) =>  {
    });
  }
}